import * as React from 'react';

import { Route, Switch } from 'react-router-dom';

import { OAUTH_CALLBACK } from '../../paths';

import { FourOhFour, Landing, Loading } from 'common/components';
import PrivateRoute from 'common/components/private-route';
import Login from 'whitelabel/concierge/Login';

// const HotelDetails = React.lazy(() =>
//   import(
//     '../../hotels/components/Details' /* webpackChunkName: "hotel_details" */
//   ),
// );
// const HotelsSearchResultsContainer = React.lazy(() =>
//   import(
//     '../../hotels/components/HotelsSearchResultsContainer' /* webpackChunkName: "hotel_search_results" */
//   ),
// );

const OauthHandler = React.lazy(() =>
  import(
    '../../auth/components/OauthHandler' /* webpackChunkName: "oauth_handler" */
  ),
);

const Results = React.lazy(() =>
  import(
    '../../tours/components/results-page' /* webpackChunkName: "search_results_tours" */
  ),
);
const ShoreExcursions = React.lazy(() =>
  import(
    '../../tours/components/ShoreExcursions' /* webpackChunkName: "shore_excursions" */
  ),
);
const TourDetails = React.lazy(() =>
  import(
    '../../tours/components/DetailsPage' /* webpackChunkName: "tour_details" */
  ),
);
const UserProfile = React.lazy(() =>
  import(
    '../../auth/components/UserProfile' /* webpackChunkName: "user_profile" */
  ),
);
const Verification = React.lazy(() =>
  import(
    '../../common/components/Verification' /* webpackChunkName: "verification" */
  ),
);
const Forbidden = React.lazy(() =>
  import('./Forbidden' /* webpackChunkName: "about_us" */),
);

const ConfirmationPage = React.lazy(() =>
  import(
    '../../confirmation/components/confirmation-page' /* webpackChunkName: "confirmation_page" */
  ),
);

const NewCheckoutPage = React.lazy(() =>
  import(
    '../../commerce/components/checkout-page'
    /* webpackChunkName: "new_checkout_page" */
  ),
);

const TourProductPage = React.lazy(() =>
  import(
    '../../tours/components/product-page' /* webpackChunkName: "new_product_page" */
  ),
);

const Routes = () => {
  return (
    <React.Suspense fallback={<Loading />}>
      <Switch>
        <PrivateRoute
          exact={true}
          path="/:lang?/confirmation"
          component={ConfirmationPage}
        />
        <PrivateRoute
          exact={true}
          path="/:lang?/tourz/:city/:productId"
          component={TourProductPage}
        />
        <PrivateRoute
          exact={true}
          path="/:lang?/new/checkout/:step(method_select|personal_info|traveler_info|questions|payment)"
          component={NewCheckoutPage}
        />
        <Route path="/login" component={Login} />
        <Route path="/:lang?/forbidden" component={Forbidden} />
        <Route path={OAUTH_CALLBACK} component={OauthHandler} />
        <PrivateRoute exact={true} path="/:lang(en|de)?" component={Landing} />

        {/* <Route
        exact={true}
        path="/:lang?/hotels/:city"
        component={HotelsSearchResultsContainer}
      /> */}

        {/* <Route
        exact={true}
        path="/:lang?/hotels/:city/:hotelId"
        component={HotelDetails}
      /> */}

        <PrivateRoute
          path="/:lang?/toursForCruises/:routeId"
          component={ShoreExcursions}
        />

        <PrivateRoute path="/:lang?/dashboard" component={UserProfile} />
        <PrivateRoute
          exact={true}
          path="/:lang?/:productType/:city"
          component={Results}
        />
        <PrivateRoute
          exact={true}
          path="/:lang?/:productType/:city/:tourTitleId"
          component={TourDetails}
        />
        <Route path="/:lang?/verification" component={Verification} />
        <Route component={FourOhFour} />
      </Switch>
    </React.Suspense>
  );
};

export default Routes;
